import Repository from "./Repository";

export default {
  /**
   * Get resource list
   */
  getResourceList(page = 1, limit = 2, circleId = 1, type, search, sort) {
    let s = search ? `&search=${search}` : "";
    let t = type ? `&type=${type}` : "";
    let srt = sort ? `&sort=${sort}` : "";
    return Repository.get(
      `/resources/?page_num=${page}&items=${limit}&circle_id=${circleId}` + s + t + srt
    );
  },

  /**
   * Get resource list
   */
  getResourceListByType(type, page = 1, limit = 2, circleId = 1, category) {
    let s = category ? `&category=${category}` : "";
    let circle_id = circleId ? `&circle_id=${circleId}` : "";

    return Repository.get(
      `/resources/?type=${type}&page_num=${page}&items=${limit}` + circle_id + s
    );
  },

  getResourceFilter(page = 1, circleId, limit = 2, category) {
    return Repository.get(
      `/resources/?page_num=${page}&circle_id=${circleId}&items=${limit}&category=${category}`
    );
  },

  /**
   * Get Quiz by ID
   *
   * @param {*} id
   * @param {*} page
   * @param {*} limit
   */
  getquiz(id, page = 1, limit = 1) {
    return Repository.get(`/quiz/?id=${id}&page_num=${page}&items=${limit}`);
  },

  /**
   * Get Article by ID
   *
   * @param {*} id
   * @param {*} page
   * @param {*} limit
   */
  getarticle(id, page = 1, limit = 1) {
    return Repository.get(`/article/?id=${id}&page_num=${page}&items=${limit}`);
  },

  /**
   * Get Article by ID
   *
   * @param {*} id
   * @param {*} page
   * @param {*} limit
   */
  getpoll(id, page = 1, limit = 1, circleId) {
    return Repository.get(
      `/polls/?id=${id}&page_num=${page}&items=${limit}&circle_id=${circleId}`
    );
  },
  postPoll(body) {
    return Repository.post(`/poll_response/`, body);
  },

  /**
   * Get Video by ID
   *
   * @param {*} id
   * @param {*} page
   * @param {*} limit
   */
  getvideo(id, page = 1, limit = 1) {
    return Repository.get(
      `/resources/?type=Videos&id=${id}&page_num=${page}&items=${limit}`
    );
  },
  getslideshow(id, circle_id, page = 1, limit = 1) {
    return Repository.get(
      `/resources/?type=slideshows&id=${id}&page_num=${page}&items=${limit}&circle_id=${circle_id}`
    );
  }
};



// WEBPACK FOOTER //
// ./src/repositories/resourceRepository.js